module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "zan-badge",
    class: _vm.classNames,
    attrs: {
      "href": _vm.url
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('div', {
    staticClass: "zan-badge__active"
  }), _vm._v(" "), (_vm.info) ? _c('div', {
    staticClass: "zan-badge__info"
  }, [_vm._v(_vm._s(_vm.info))]) : _vm._e(), _vm._v("\n  " + _vm._s(_vm.title) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2a98dcb3!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/badge/src/badge.vue
// module id = 164
// module chunks = 0 2